/* eslint-env es6 */
const state = {
  keyWord: '',
  liveShopOBj: {},
  channelBrand: 0
}
export default state
